import { Drawer } from '@procurify/ui'

import {
  type IMessageThreadProps,
  MessageThread,
  ThreadTitleStyled,
} from '../MessageThread'
import { DrawerThreadBoxStyled } from './styles/MessageThreadDrawerStyled'

const MIN_WIDTH = '400px'

export interface IMessageThreadDrawerProps extends IMessageThreadProps {
  open: boolean
}

export const MessageThreadDrawer = ({
  open,
  title,
  onClose,
  ...thread
}: IMessageThreadDrawerProps) => (
  <Drawer
    drawerOpen={open}
    setDrawerOpen={() => onClose?.()}
    minWidth={MIN_WIDTH}
    DrawerProps={{
      renderTitle: () => (
        <ThreadTitleStyled forwardedAs='h3'>{title}</ThreadTitleStyled>
      ),
    }}
  >
    {() => (
      <DrawerThreadBoxStyled>
        <MessageThread {...thread} />
      </DrawerThreadBoxStyled>
    )}
  </Drawer>
)

MessageThreadDrawer.displayName = 'MessageThreadDrawer'
